<template>
    <div class="block-course" :class="secondarySectionOpened ? 'opened' : ''">
        <section class="primary-section">
            <div
                class="summary-image"
                v-bind:style="{
                    backgroundImage: 'url(' + order.course.image + ')',
                }"
                aria-hidden="true"
            >
                <div class="summary-location">
                    <span
                        class="icon-online"
                        v-if="order.course.is_online"
                    ></span>
                    {{
                        order.course.is_online
                            ? app.locale.trans('course.online.title')
                            : order.city.name
                    }}
                </div>
            </div>

            <div class="summary-content">
                <h5>
                    <a :href="order.course.url">
                        <span class="badges">
                            <span
                                v-if="order.getBadge()"
                                class="badge badge-pill badge-primary"
                                v-html="trans(order.getBadge())"
                            ></span>
                            <span
                                v-if="order.coupon"
                                class="badge badge-pill badge-success"
                            >
                                {{ trans('user.cart.discounted') }}
                            </span>
                        </span>
                        {{ order.title() }}
                    </a>
                </h5>
                <div class="order-details">
                    <div
                        v-if="!order.isPast() && order.isCancelled()"
                        class="alert alert-warning"
                    >
                        <i class="fa fa-info-circle"></i>
                        {{ app.locale.trans('user.courses.cancelled') }}
                    </div>
                    <div v-html="order.course.in_short"></div>
                    <span v-if="order.bookingReference">
                        {{ trans('user.courses.reference') }}
                        {{ order.bookingReference }}
                    </span>
                    <component :is="detailComponent" :order="order"></component>
                    <slot name="order-details"></slot>
                </div>
            </div>
            <div class="summary-quantity" v-if="editable">
                <select
                    class="input-select-rounded"
                    v-model="order.quantity"
                    :disabled="!order.allowChangeQuantity"
                    @change="
                        order.allowChangeQuantity && changeQuantity($event)
                    "
                >
                    <option v-for="n in 10" v-bind:key="n" :value="n">
                        {{ n }}
                    </option>
                </select>
            </div>
            <div class="summary-price">
                <span class="price">
                    {{
                        this.app.formatPrice(
                            order.calcPriceDiscounted() || order.calcPrice(),
                            order.currency.code
                        )
                    }}
                </span>
                <div v-if="order.calcPriceDiscounted()" class="old-price">
                    <del>
                        {{
                            this.app.formatPrice(
                                order.calcPrice(),
                                order.currency.code
                            )
                        }}
                    </del>
                </div>
            </div>
            <div v-if="editable" class="primary-section-icon summary-remove">
                <span
                    class="remove-icon"
                    v-on:click="remove(order.id)"
                    title="Retirer le ticket du panier"
                >
                    <i class="fas fa-times"></i>
                </span>
            </div>
            <slot name="primary-section-icons"></slot>
        </section>
        <slot v-if="secondarySectionOpened" name="secondary-section"></slot>
    </div>
</template>

<script>
import CourseOrderCourseDetail from './CourseOrderCourseDetail.vue';
import CourseOrderPackDetail from './CourseOrderPackDetail.vue';
import { ALLOWED_COURSES_TYPES } from './../../../../../const/Globals.ts';
import CourseOrder from './../../../../../class/CourseOrder';

export default {
    props: {
        order: {
            type: CourseOrder,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: false,
        },
        secondarySectionOpened: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        CourseOrderCourseDetail,
        CourseOrderPackDetail,
    },

    data() {
        return {
            opened: false,
            userTimeZone: this.app.locale.getUserTimezone(),
        };
    },

    computed: {
        detailComponent() {
            if (ALLOWED_COURSES_TYPES.includes(this.order.type)) {
                return (
                    'CourseOrder' +
                    this.app.string.capitalize(this.order.type) +
                    'Detail'
                );
            }
            return null;
        },
    },

    methods: {
        changeQuantity: function (event) {
            this.$parent.loading = true;

            this.$parent.cartApiService
                .updateCartItem(
                    this.order.id,
                    this.order.price,
                    event.target.value
                )
                .then((data) => {
                    // Update global data for further events.
                    appData.page.vars.gtmData = data.data.gtmData;

                    // Reloading cart
                    this.$parent.loadCart();
                })
                .catch((error) => {
                    this.$parent.$refs.alertBox.handleError(error);
                });
        },

        remove: function (ticketId) {
            this.$parent.loading = true;
            this.$parent.cartApiService
                .destroyCartItem(ticketId)
                .then((gtmData) => {
                    // Update global data for further events.
                    appData.page.vars.gtmData = gtmData;
                    this.app.gtm.trigger('remove_from_cart', gtmData);

                    // Reloading cart
                    this.$parent.loadCart();
                })
                .catch((error) => {
                    this.$parent.$refs.alertBox.handleError(error);
                });
        },
    },
};
</script>
